import React, { useContext } from 'react';
import { ModalAddEmployee } from './ModalAddEmployee';
import { useNavigate } from 'react-router-dom';
import { BrokersContext } from 'contexts/Brokers/Brokers';
import Analytics from 'helpers/analytics';
import { ModalUploadEmployee } from './ModalUploadEmployee';
import { ModalSuccess } from './ModalSuccess';
import { ModalResignationEmployee } from './ModalResignationEmployee';
export const ModalHandler = () => {
	const navigate = useNavigate();
	const { isBroker } = useContext(BrokersContext);

	const [modalsState, setModalsState] = React.useState({
		mainModalAddEmployee: false,
		modalAddEmployee: false,
		modalResignationEmployee: false,
		modalEmployeeSuccess: false,
	});

	const handleSuccess = () => {
		setModalsState((prev) => ({
			...prev,
			modalAddEmployee: false,
			modalEmployeeSuccess: true,
		}));
	};

	const handleAddEmployee = () => {
		Analytics.track('employee', 'Initiated Create Employee', {
			isBroker,
		});

		navigate('/employee');

		setModalsState((prev) => ({
			...prev,
			modalAddEmployee: false,
			mainModalAddEmployee: false,
		}));
	};

	const handleOpenModalUpload = () => {
		setModalsState((prev) => ({
			...prev,
			modalAddEmployee: true,
			mainModalAddEmployee: false,
		}));
	};

	const handleToggleMainModal = (state: boolean) => {
		setModalsState((prev) => ({
			...prev,
			mainModalAddEmployee: state,
		}));
	};

	const handleToggleResignationModal = (state: boolean) => {
		setModalsState((prev) => ({
			...prev,
			modalResignationEmployee: state,
		}));
	};

	const handleClickAddEmployee = () => {
		handleAddEmployee();
	};

	return (
		<>
			<ModalAddEmployee
				open={modalsState.mainModalAddEmployee}
				onOpen={handleClickAddEmployee}
				onClose={() => handleToggleMainModal(false)}
				onAddSingleEmployee={handleAddEmployee}
				onAddMultipleEmployees={handleOpenModalUpload}
			/>
			<ModalUploadEmployee
				open={modalsState.modalAddEmployee}
				onSuccess={handleSuccess}
				onClose={() =>
					setModalsState((prev) => ({
						...prev,
						modalAddEmployee: false,
						mainModalAddEmployee: true,
					}))
				}
			/>
			<ModalResignationEmployee
				open={modalsState.modalResignationEmployee}
				onOpen={() =>
					setModalsState((prev) => ({
						...prev,
						modalResignationEmployee: true,
					}))
				}
				onSuccess={() =>
					setModalsState((prev) => ({
						...prev,
						modalResignationEmployee: false,
						modalEmployeeSuccess: true,
					}))
				}
				onClose={() => handleToggleResignationModal(false)}
			/>
			<ModalSuccess
				open={modalsState.modalEmployeeSuccess}
				onClose={() =>
					setModalsState((prev) => ({
						...prev,
						modalEmployeeSuccess: false,
					}))
				}
			/>
		</>
	);
};
